import {find, times} from 'lodash'
import * as React from 'react';
import './App.css';
import Fretboard from './components/fretboard';
import { IChord, IScale, ITuning } from './models';
import { NOTES } from './modules/utils';

import {
  generateScale,
  parseTuning,
} from './modules/utils'

declare global {
  // tslint:disable-next-line
  interface Window {
    askUser: any;
  }
}

interface IAppProps {
  readonly chords: ReadonlyArray<IChord>
  readonly scales: ReadonlyArray<IScale>
  readonly tunings: ReadonlyArray<ITuning>
}

class App extends React.Component<IAppProps> {

  public state = {
    chord: null,
    customTuning: '',
    intervals: {
      1: true,
      2: true,
      3: true,
      4: true,
      5: true,
      6: true,
      7: true
    },
    key: NOTES[7],
    numberOfFrets: 24,
    rootNote: NOTES[7],
    scale: this.props.scales[0],
    tuning: this.props.tunings[0],
  }

  public render() {
    const {tunings, scales} = this.props
    const scale = generateScale(this.state.key, this.state.scale.skips)

    return (
      <div className='app'>
        <div id="contact_link">
          <a href="#" onClick={this.triggerAskUser}>
            Contact Me
          </a>
        </div>
        <h1>Fretboard Navigator <span className='beta-tag'>beta</span></h1>
        <div className='scale'>
          {this.renderFretboard()}
        </div>

        <div className='control-panel'>
          <div className='column'>
            <form onSubmit={this.onFormSubmit} className="pure-form pure-form-stacked">
              <fieldset>
                <legend>Tuning & Scales</legend>

                <div className="pure-control-group">
                  <label htmlFor="tuning">Tuning</label>
                  <select className="field" id="tuning" onChange={this.tuningChange} value={this.state.tuning.name}>
                      {tunings.map((t, i) => <option key={i} value={t.name}>{t.name}</option> )}
                  </select>
                </div>

                <div className="pure-control-group">
                  <label htmlFor="customTuning">Custom Tuning</label>
                  <input className="field" name="customTuning" type="text" value={this.state.customTuning} onChange={this.customTuningChange}/>
                </div>

                <div className="pure-control-group">
                  <label htmlFor="key">Key</label>
                  <select className="field" id="key" onChange={this.keyChange} value={this.state.key}>
                    {NOTES.map((t: string, i: number) => <option key={i} value={t}>{t}</option> )}
                  </select>
                </div>

                <div className="pure-control-group">
                  <label htmlFor="scale">Scale</label>
                  <select className="field" id="scale" onChange={this.scaleChange} value={this.state.scale.name}>
                      {scales.map((t, i) => <option key={i} value={t.name}>{t.name}</option> )}
                  </select>
                </div>

                {/*<div className="pure-control-group">
                  <label htmlFor="numberOfFrets">Number Of Frets </label>
                  <input name="numberOfFrets" type="text" value={this.state.numberOfFrets} onChange={this.numberOfFretsChange.bind(this)}/>
                </div>-->*/}
              </fieldset>
            </form>
            <div>
              { this.state.tuning.desc }
            </div>
          </div>

          <div className='column is-center'>
            <form className="pure-form pure-form-stacked">
              <fieldset>
                <legend>
                  {/* <a href="#" onClick={this.selectIntervalsTab}>Intervals</a> */}
                  Intervals
                </legend>

                {this.state.intervals &&
                  <div className='intervals-section'>
                    <div>
                      <div>Select Root Note:</div>
                      <select onChange={this.setRootNote}>
                        <option value={undefined}>---</option>
                        {scale.map(note => (
                          <option selected={note === this.state.rootNote} value={note}>{note}</option>
                        ))}
                      </select>
                    </div>
                    
                    <div>
                      <div>Select Intervals:</div>
                      <div className='intervals-block'>
                        {times(this.state.scale.skips.length - 1, (i) => {
                          const j = i+1;
                          return <div className={this.state.intervals[j+1] ? 'selected' : ''} onClick={this.toggleInterval.bind(this, j+1)}>
                            {j+1}
                            {/* <input type='checkbox' onChange={this.toggleInterval.bind(this, i+1)} checked={this.state.intervals[i+1]}/> */}
                          </div>
                        })}
                      </div>
                    </div>
                  </div>
                }

                {/* {!this.state.intervals &&
                  <div className='chord-table'>
                      <div className='chord-table-column'>Root: </div>

                      {scale.map((note) => (
                        <div className='chord-table-column'>
                          <div className='chord-table-root-note'>
                            <a
                              className={this.state.rootNote === note ? 'active': ''}
                              href="#"
                              onClick={this.rootNoteChange.bind(this, note)}>
                              {note}
                            </a>
                          </div>

                          {this.getChords(note).map((chord, i) => {
                            return (<div key={i} className='chord-table-chord'>
                                <a className={this.state.chord === chord ? 'active': ''}
                                onClick={this.selectChord.bind(this, chord, note)}
                                href='#'>
                                {chord.name.replace('@', note)}
                              </a>
                            </div>)
                          })}
                        </div>
                      ))}
                  </div>
                } */}
              </fieldset>
            </form>
          </div>

          <div className='column'>
            <form className="pure-form" >
              <fieldset>
                <legend>Recommendations</legend>

                <div className='youtube-text-block youtube-link'>
                  Youtube channels with a lot of information on how to use alternate tunings and compose in them.
                </div>
                <br/>
                <div className='youtube-link'>
                  <div className="g-ytsubscribe" data-channelid="UC9zrdUfI9Ern67Ax657gEkg" data-layout="full" data-count="default" />
                </div>
                <div className='youtube-link'>
                  <div className="g-ytsubscribe" data-channelid="UCUERVRulpmC0DMspYCXlqaw" data-layout="full" data-count="default" />
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    );
  }

  private triggerAskUser () {
    // Show question: Message:
    window.askUser.show({
      questionId: "-LBReUWh6tdzUCKBlNTi",
      rotate: true // 👈 Always show this question
    })
  }

  private onFormSubmit (event: React.SyntheticEvent<any>) {
    event.preventDefault()
  }

  // private selectChord = (chord: IChord, rootNote: string) => {
  //   this.setState({chord, rootNote})
  // }

  private renderFretboard () {
    const tuningNotes = this.state.tuning.notes
    // tslint:disable-next-line
    console.log('before fret render', this.state)
    return <Fretboard 
      tuningNotes={tuningNotes} 
      scale={this.state.scale} 
      chord={this.state.chord}
      intervals={this.state.intervals}
      scaleKey={this.state.key}
      rootNote={this.state.rootNote}
    />
  }

  private scaleChange = (event: React.SyntheticEvent<any>) => {
    const target = event.target as HTMLInputElement;
    const scale = find(this.props.scales, {name: target.value});
    this.setState({rootNote: this.state.key, scale})
  }

  private keyChange = (e: React.SyntheticEvent<any>) => {
    const target = e.target as HTMLInputElement;
    const key = target.value;
    this.setState({key, rootNote: key});
  }

  private tuningChange = (event: React.SyntheticEvent<any>) => {
    const target = event.target as HTMLInputElement;
    const tuning = find(this.props.tunings, {name: target.value})
    this.setState({tuning, customTuning: ''})
  }

  // private numberOfFretsChange (event: React.SyntheticEvent<any>) {
  //   let target = event.target as HTMLInputElement;
  //   const val = target.value
  //   this.setState({numberOfFrets: val})
  // }

  // private rootNoteChange = (val: string) => {
  //   this.setState({chord: null, rootNote: val})
  // }

  private setRootNote = (event: React.SyntheticEvent<any>) => {
    const target = event.target as HTMLInputElement;
    this.setState({rootNote: target.value})
  }

  private customTuningChange = (event: React.SyntheticEvent<any>) => {
    const target = event.target as HTMLInputElement;
    const val = target.value
    if (val.length === 0) {
      this.setState({customTuning: val, tuning: this.props.tunings[0]})
    } else {
      this.setState({
        customTuning: val,
        tuning: {notes: parseTuning(val).reverse()}
      })
    }
  }

  // private getChords (note: string) {
  //   if (!this.state.scale) { return [] }
  //   const scaleNotes = generateScale(this.state.key, this.state.scale.skips)
  //   return this.props.chords.filter((chord) => {
  //       return chord.key === scaleNotes.indexOf(note) + 1 // coz we are counting from 1
  //   })
  // }

  // private selectIntervalsTab = () => {
  //   this.setState({
  //     chord: null,
  //     rootNote: this.state.scale.startingNote,
  //   })
  // }

  private toggleInterval = (interval: number) => {
    const newState = Object.assign({}, this.state)
    newState.intervals[interval] = !this.state.intervals[interval]
    this.setState(newState)
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx